export default [
  {
    path: '/mobileWeCom',
    component: () => import(/* webpackChunkName: 'mobileWeCom' */'@/views/mobileWeCom/index'),
    meta: { requiresAuth: true },
  },
  {
    path: '/mobileWeCom/worktime',
    component: () => import(/* webpackChunkName: 'mobileWeComWorktime' */'@/views/mobileWeCom/worktime'),
    meta: { requiresAuth: true },
  },
  {
    path: '/mobileWeCom/approval',
    component: () => import(/* webpackChunkName: 'mobileWeComApproval' */'@/views/mobileWeCom/approval'),
    meta: { requiresAuth: true },
  },
  {
    path: '/mobileWeCom/subject',
    component: () => import(/* webpackChunkName: 'mobileWeComSubject' */'@/views/mobileWeCom/subject'),
    meta: { requiresAuth: true },
  },
  {
    path: '/mobileWeCom/subjectList',
    component: () => import(/* webpackChunkName: 'mobileWeComSubjectList' */'@/views/mobileWeCom/subjectList'),
    meta: { requiresAuth: true },
  },
  {
    path: '/mobileWeCom/visit',
    component: () => import(/* webpackChunkName: 'mobileWeComVisit' */'@/views/mobileWeCom/visit'),
    meta: { requiresAuth: true },
  },
  {
    path: '/mobileWeCom/mine',
    component: () => import(/* webpackChunkName: 'mobileWeComMine' */'@/views/mobileWeCom/mine'),
    meta: { requiresAuth: true },
  },
  {
    path: '/mobileWeCom/empty',
    component: () => import(/* webpackChunkName: 'mobileWeComJump' */'@/views/mobileWeCom/empty'),
    meta: { requiresAuth: false },
  }
]
